var _style, _polygon, _polygon2, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -223.073,
    y1: 274.7689,
    x2: -222.9807,
    y2: 274.9528,
    gradientTransform: "matrix(256 0 0 -128.4267 57120 35349.332)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09677,
    style: {
      stopColor: "#0095D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3007,
    style: {
      stopColor: "#238AD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6211,
    style: {
      stopColor: "#557BDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8643,
    style: {
      stopColor: "#7472E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#806EE3"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,50 25.1,24.9 50,50  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -222.2286,
    y1: 274.3122,
    x2: -222.1217,
    y2: 274.4111,
    gradientTransform: "matrix(128.4267 0 0 -138.6667 28543.5742 38048)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1183,
    style: {
      stopColor: "#0095D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4178,
    style: {
      stopColor: "#3C83DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6962,
    style: {
      stopColor: "#6D74E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8333,
    style: {
      stopColor: "#806EE3"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,0 25.1,0 0,27.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -223.1579,
    y1: 274.9455,
    x2: -222.9762,
    y2: 275.1272,
    gradientTransform: "matrix(256 0 0 -256 57120 70432)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1075,
    style: {
      stopColor: "#C757BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2138,
    style: {
      stopColor: "#D0609A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4254,
    style: {
      stopColor: "#E1725C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6048,
    style: {
      stopColor: "#EE7E2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    style: {
      stopColor: "#F58613"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8232,
    style: {
      stopColor: "#F88909"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "25.1,0 0,26.4 0,50 25.1,24.9 50,0  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.bc9f0576068fab74243a5e4fd61d998d.svg";
export { ForwardRef as ReactComponent };